<template>
    <div class="uloha-btn" :class="{'uloha-btn--inprogress' : uloha.status === 'aktivna', 'uloha-btn--locked': uloha.status === 'buduca' }">
        <span class="status" :class="{ 'status--done': isDone, 'status--open': isOpen, 'status--pending': isPending, 'status--locked': isLocked, 'status--failed': isFalse }" />
        <span class="main-icon" :class="{'icon--kviz': typ === 'kvizova',  'icon--tvoriva': typ === 'tvoriva' }"></span>
        <div v-if="!hideProgress" class="progress" :class="{ 'progress--warning': progress < 80, 'progress--done': progress >= 80 }">
            <span class="progress-bg" :style="{ width : progress + '%' }"></span>
            <span class="progress-value">{{ progress }}%</span>
        </div>
        <router-link v-if="isEditable" :to="{ name: `skoly-ulohy-${uloha.typ}`, params: { uloha_id: uloha.id } }" class="stretched-link" />
    </div>
</template>

<script>
export default {
    components: {},
    props: [ 'uloha', 'typ', 'profil' ],
    data() {
        return {}
    },
    computed: {
        isDone() {
            return this.uloha.status === 'minula' && this.uloha.is_vyplnena === true
        },
        isFalse() {
            return this.uloha.status === 'minula' && this.uloha.is_vyplnena === false
        },
        isOpen() {
            return this.uloha.status === 'aktivna' && this.uloha.is_vyplnena === false
        },
        isPending() {
            return this.uloha.status === 'aktivna' && this.uloha.is_vyplnena === true
        },
        isLocked() {
            return this.uloha.status === 'buduca'
        },
        hideProgress() {
            return this.uloha.status === 'buduca' || this.uloha.is_vyplnena === false
        },
        isEditable() {
            if ( this.uloha.status === 'minula' ) {
                return false
            }

            if ( this.uloha.status === 'aktivna' && this.uloha.typ === 'kvizova' && this.uloha.is_vyplnena === true ) {
                return false
            }

            return true
        },
        progress() {
            if ( this.uloha.vypracovania && this.uloha.vypracovania.length ) {
                let vypracovanie = this.uloha.vypracovania[0]
                if ( this.uloha.typ === 'tvoriva' ) {
                    if ( this.uloha.is_individualna ) {
                        return Math.round( 100 * vypracovanie.subory.length / this.profil.pouzivatel_id.pouzivatel_pocet_ziakov )
                    } else {
                        return Math.round(100 * vypracovanie.subory.length )
                    }
                } else {
                    let percent = Math.round( 100 * vypracovanie.pocet_bodov / this.uloha.pocet_bodov)
                    return ( percent <= 100 ) ? percent : 100
                }
            } else {
                return 0
            }
        }
    },
    mounted() {
    },
    methods: {}
}
</script>
